import CustomWrapper from "components/Chakra/CustomWrapper";
import Tabs from "components/Tabs";
import { useStoryblokTypeUser } from "contexts/StoryblokTypeUser";
import { firstTabItems } from "./TabContent/FirstTab";
import { secondTabItems } from "./TabContent/SecondTab";
import { thirdTabItems } from "./TabContent/ThirdTab";
import IconKey from "components/Chakra/Icons/Key";
import IconBriefcase from "components/Chakra/Icons/Briefcase";
import IconHouse from "components/Chakra/Icons/House";
import { GridLayout } from "components/Chakra/GridLayout";

const listTabs = [
  {
    tab: {
      text: "Pro majitele",
      icon: <IconKey boxSize="18px" />,
    },
    title: "Užitečné služby pro majitele nemovitostí",
    content: (
      <GridLayout
        templateAreas={{
          base: "none",
          md: `
            "A A B B D D"
            "A A C C D D"
            "E E F F G G"
            "H H F F CH CH"
            "I I I J J J"
          `,
        }}
        items={firstTabItems}
      />
    ),
  },
  {
    tab: {
      text: "Pro makléře",
      icon: <IconBriefcase boxSize="18px" />,
    },
    title: "Profesionální  nástroje pro realitní činnost",
    content: (
      <GridLayout
        templateAreas={{
          base: "none",
          md: `
      "A A B B C C"
      "A A B B C C"
      "D D E E F F"
    `,
        }}
        templateRows={{
          base: "none",
          md: "1fr repeat(2, 240px)",
        }}
        items={secondTabItems}
      />
    ),
  },
  {
    tab: {
      text: "Pro zájemce",
      icon: <IconHouse boxSize="18px" />,
    },
    title: "Najděte váš nový domov na jeden klik",
    content: (
      <GridLayout
        templateAreas={{
          base: "none",
          md: `
      "A A A B B B"
      "C C D D E E"
      "C C D D E E"
    `,
        }}
        templateRows={{
          base: "none",
          md: "1fr repeat(2, 240px)",
        }}
        items={thirdTabItems}
      />
    ),
  },
];

const TabsWrapper = () => {
  const { userType } = useStoryblokTypeUser();

  const getSelectIndex = (): number => {
    switch (userType) {
      case "PRIVATE_LANDLORD":
        return 0;
      case "REAL_ESTATE_BROKER":
        return 1;
      case "INTERESTED_IN_HOUSING":
        return 2;
      default:
        return 0;
    }
  };

  return (
    <CustomWrapper mt={{ base: "40px", md: "80px" }} maxW="1360px" id="tabs">
      <Tabs indexSelected={getSelectIndex()} listTabs={listTabs} />
    </CustomWrapper>
  );
};

export default TabsWrapper;
